import { render, staticRenderFns } from "./tutorsList.vue?vue&type=template&id=675e6e65&scoped=true&"
import script from "./tutorsList.vue?vue&type=script&lang=js&"
export * from "./tutorsList.vue?vue&type=script&lang=js&"
import style0 from "./tutorsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tutorsList.vue?vue&type=style&index=1&id=675e6e65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e6e65",
  null
  
)

export default component.exports